import { render, staticRenderFns } from "./step5.vue?vue&type=template&id=7b5f5a0a&scoped=true&"
import script from "./step5.vue?vue&type=script&lang=js&"
export * from "./step5.vue?vue&type=script&lang=js&"
import style0 from "./step5.vue?vue&type=style&index=0&id=7b5f5a0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5f5a0a",
  null
  
)

export default component.exports